import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import { CaptureConsole } from '@sentry/integrations';
import reportWebVitals from "./reportWebVitals";
import { env as environment } from "./controllers/environment";
import { tagAxiosError } from "./controllers/sentryTags";

if (environment.environment === "prod") console.log = () => {};

Sentry.init({
	dsn: environment.sentryDSN,
	integrations: [
		new Sentry.BrowserTracing(),
		new CaptureConsole({
			levels: ['error']
		})
	],

	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1.0,
	beforeSend: tagAxiosError,
});
// === Frame-busting: prevent CBRE app from rendering inside its own iframe ===
// Auto-process flow: verification.diro.live redirects its iframe to a CBRE
// app URL, which would otherwise load the full CBRE app a second time inside
// the iframe — producing a duplicate Header/Sidebar AND CORS-blocked API
// calls (api2.diro.live rejects the iframe's origin).
//
// Detection:
//   - "Nested-CBRE" = we're inside an iframe whose parent is also CBRE
//     (same origin). This is the bug case.
//   - Cross-origin parent = legitimate embed (*.diro.io / *.diro.live per
//     frame-ancestors in serve.json) — leave it alone.
//
// Behaviour:
//   - Nested-CBRE: post a message to the parent so it reloads, AND skip
//     React mount entirely so no Header/Sidebar/UI ever renders inside the
//     iframe (avoids the visible double-header even briefly).
//   - Top window: listen for the message and reload when received.
//     Verification.js's useEffect then navigates to /buttons/{email} on the
//     fresh load (inputEmail React state is gone, localStorage keeps it).
let isNestedCbre = false;
if (window.self !== window.top) {
	try {
		isNestedCbre = window.top.location.origin === window.self.location.origin;
	} catch (e) {
		// Cross-origin parent — treat as legitimate embed.
		isNestedCbre = false;
	}
	try {
		window.parent.postMessage({ type: "__CBRE_NESTED__" }, "*");
	} catch (e) {
		/* unable to postMessage — leave alone */
	}
} else {
	window.addEventListener("message", (e) => {
		if (e?.data?.type === "__CBRE_NESTED__") {
			window.location.reload();
		}
	});
}

if (!isNestedCbre) {
	const root = ReactDOM.createRoot(document.getElementById("root"));
	root.render(<App />);

	reportWebVitals();
}
